import axios from "axios"
import { Entity } from "./Models"
import {simplify} from "../utils/simplify";

export class Api {

    async getTrail(url: string, options?: { language?: string, key?: string }): Promise<Entity> {
        const headers: any = {
            "Accept-Language": options?.language || "fr",
        }




        try {
            const res = await axios.get(url, { headers: headers })

            let i = 0
            let oldLength = res.data?.trail?.geometry?.length

            while(res.data?.trail?.geometry?.length > 8000)
            {
                const tolerance = 0.00005 + (i * 0.00001);
                const highQuality = false;
                res.data.trail.geometry = simplify(res.data.trail.geometry,  tolerance, highQuality);
                i++;
            }
            console.info(`Route simplified from ${oldLength} to ${res.data?.trail?.geometry?.length} points`)

            return res.data as Entity
        } catch (error) {
            throw error
        }
    }
}

